import { object, func } from 'prop-types'

import scope from 'recompose-scope/composeWithScope'
import consumeProps from 'recompose-scope/consumeProps'
import injectProps from 'recompose-scope/injectProps'
import exposeProps from 'recompose-scope/exposeProps'

import withState from 'recompose/withState'
import withProps from 'recompose/withProps'

import interceptUpdater from 'coact-utils/interceptUpdater'

import controlEditor from 'coact/controlEditor'
import objectEditorEnhancer from 'coact/objectEditorEnhancer'


import EditorView from './Editor'


const Editor = scope(
  // schema, auth, db, page, uiSetting
  consumeProps({
    auth: object,
    db: object,
    page: object,
    schema: object,
    uiSetting: object,
  }),
  injectProps({
    validator: func,
    computer: func,
  }),

  withState('value', 'onChange', null),

  objectEditorEnhancer, // => spliter

  // x-auth, x-schema, x-db, x-page
  controlEditor, // => actions

  // x-uiSetting
  withProps(({ uiSetting, schema }) => ({
    ui: {
      title: schema.name,
      ...uiSetting.editor,
    },
  })), // => ui

  interceptUpdater('onChange', () => value => ({
    ...value,
  })),

  exposeProps([
    'value',
    'onChange',
    'schema',
    'spliter',
    'saveEditing',
    'cancelEditing',
    'routeToNewDoc',
    'routeToCopyDoc',
    'ui',
  ]),
)(EditorView)

Editor.displayName = 'productsBEditor'

export default Editor



// WEBPACK FOOTER //
// ./src/components/products/productsB/index.js